export const frontendVersion = '1.1.57 (2f3698c0)';
